import { render } from "./FooterActions.vue?vue&type=template&id=01b8ba9b&scoped=true"
import script from "./FooterActions.vue?vue&type=script&lang=js"
export * from "./FooterActions.vue?vue&type=script&lang=js"

import "./FooterActions.vue?vue&type=style&index=0&id=01b8ba9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b8ba9b"]])

export default __exports__